export type IViewVideo = {
    type: "video",
    name: string,
    video: string,
    looping?: boolean,
    description?: string,
    condition?: string[]
}
export type IViewCamera = {
    type: "camera" | "view" | "viewpoint",
    name: string,
    camera: string,
    description?: string,
    /// If not set, then "All"
    levelgroup?: string,
    // If set, lists out the conditions when this camera should be shown
    // For now, we only support "markethome" in which case the camera is only present for market homes.
    condition?: string[]
}
export type IViewMap = {
    /**
     * 2D community map
     */
    type: "map",
    name: string,
    condition?: string[]
    description?: string,
    /**
     * Optionally specify the SVG viewbox.
     * X, Y, Width, Height
     */
    viewBox?: [number, number, number, number]


}
export type IViewItemImage = {
    /**
     * Shows a named image attached to the slsord (or maybe later the community),
     * e.g. firstfloor or elevation
     */
    type: "image",
    name: string,
    // "elevation", "firstfloor" etc.
    imageId?: string;
    image?: string;
    condition?: string[],
    description?: string
}
export type IViewItemConfig = IViewCamera | IViewVideo | IViewMap | IViewItemImage

export interface IViewConfig {
    name: string;
    items: IViewItemConfig[];
}

export type IOptionConfig = string | { id: string, name: string };

export interface IModelConfigData {
    /// Which options should be shown for market homes.
    marketHomeOptions?: IOptionConfig[];
    views: IViewConfig[];
    options: IOptionConfig[];
    /**
     * What is the ID used in unreal, e.g. for Kova model 9981CO the unreal ID might be 9981.
     * If undefined, then kova model ID = unreal model ID.
     */
    unrealId?: string;

    /**
     * What is the Lot ID used in unreal. If not specified, then "GenLot"
     */
    lotId?: string;
    // If specified, we are using the new protocol for communicating with the new VSC.
    type?: "vsc";

    // If specified, then we can use cameras that refer to the viewpoint in the viewpoint JSON.
    viewpointGroup?: string;
}

export interface IViewpoint {
    Name: string;
    DisplayName: string;
    Location: {
        X: number;
        Y: number;
        Z: number;
    },
    LookAtDirection: {
        X: number;
        Y: number;
        Z: number;
    }
}

export interface IViewpointGroup {
    Name: string;
    Viewpoints: IViewpoint[];
}

export interface IViewpointGroupJson {
    ViewpointGroup: IViewpointGroup;
}

export interface IModelConfig extends IModelConfigData {
    viewpointGroupDefinition?: IViewpointGroup;
}

export function filterViewItems(viewItems: IViewItemConfig[], conditions: string[]) {

    // Filter out all viewitems where we can't find a required condition in the conditions array.
    return viewItems.filter(vi => {
        for (const vic of vi.condition ?? []) {
            if (!conditions.includes(vic)) {
                return false;
            }
        }
        return true;
    });
}